import axios from "@/config/http";
import ip from "../config/ip.js";

let base = ip.Ips.ip1
// let base = "";

// 2019-9-29 首页-市区接口
export const cityData = params => {return axios.get(`${base}/web/baseData/getRegionList`,{params:params});}
//获取验证码
export const createVcode = params => {return axios.get(`${base}/web/baseData/getVerCode`,{params:params});}
//校验验证码
export const vertifyCode = params => {return axios.get(`${base}/web/baseData/vertify_code`,{params:params});}
//一键下单
export const createOrder = params => {return axios.post(`${base}/web/customer_order/userAddOrder`,params);}



// WEBPACK FOOTER //
// ./src/api/api.js